import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import {withRouter} from "react-router";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./CreateStockTransferForm";
import {cancelCreateStockTransfer} from "../../../actions/StockTransferApiActions";
import {getAllWarehouses} from "../../../lib/Warehouses";
import {Map} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "originWarehouseId");
  errors = validatePresence(errors, values, "destinationWarehouseId");
  errors = validatePresence(errors, values, "transportType");
  return errors.toJS();
}

class CreateStockTransferFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.createStockTransfer(values.toJS())
      .then((response) => {
        if (response.data.createStockTransfer.errors.length <= 0) {
          this.props.cancelCreateStockTransfer();
          this.props.router.push(`/stock-transfers/${response.data.createStockTransfer.id}`);
        } else {
          let errors = createValidationErrors(response.data.createStockTransfer.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelCreateStockTransfer();
  }

  render() {
    return (
      <Form
        warehouses={getAllWarehouses()}
        errors={this.state.errors}
        validate={validateForm}
        submitLabel="Create"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const CREATE_STOCK_TRANSFER = gql`
  mutation createStockTransfer($data: CreateStockTransferInput!) {
    createStockTransfer(input: $data) {
      id
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(CREATE_STOCK_TRANSFER, {
    props: ({ mutate }) => ({
      createStockTransfer: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelCreateStockTransfer})(withRouter(withMutation(CreateStockTransferFormContainer)));
